module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 168
// module chunks = 2